
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/categories/[...slug]",
      function () {
        return require("private-next-pages/categories/[...slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/categories/[...slug]"])
      });
    }
  